<template>
<v-card>
  <v-card-title>
    Edit Customer - {{ propCustomer.name }}

  <div class="flex-grow-1"></div>
    <v-btn icon @click="closeEdit">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <v-card-text>
    <v-row v-for="(value, key) in propCustomer" :key="key">
      <!-- key -->
      <v-col class="mt-2 text-right font-weight-light" v-if="!excludedFields.includes(key)">{{ key }}</v-col>
      <!-- <v-col class="text-right font-weight-light" v-else>{{ key }}</v-col> -->

      <!-- value -->
      <v-col class="text-left" v-if="!excludedFields.includes(key)">
        <v-text-field solo class="my-0" v-model="propCustomer[key]" dense @keyup.enter="saveChanges" @keyup.esc="closeEdit"></v-text-field>
      </v-col>
      <!-- <v-col class="text-left font-weight-bold" v-else>{{ value }}</v-col> -->
    </v-row>

    <v-row v-if="errorMessage">
      <v-col>
        {{ errorMessage }}
      </v-col>
    </v-row>

    <v-row>
      <div class="flex-grow-1"></div>

      <v-col class="text-right">
        <v-btn class="mr-3" color="success" @click="saveChanges" :loading="loading">
          Save
        </v-btn>
        <VerifyDialog
          :propBtnColor="'red'"
          :propBtnDisabled="loading"
          :propBtnDark="true"
          :propActionBtnName="'Delete'"
          :propTitle="`Delete customer ${propCustomer.name}?`"
          :propText="`Are you sure you want to delete customer ${propCustomer.name}?`"
          :propBtnVerify="'Yes'"
          :propBtnCancel="'Cancel'"
          @verify="deleteCustomer"
          />
        <v-btn @click="closeEdit" :disabled="loading">
          Cancel
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>

</template>

<script>
import axios from 'axios'
import VerifyDialog from '@/components/VerifyDialog'

export default {
  name: 'EditCustomer',

  components: {
    VerifyDialog
  },

  props: ['propCustomer'],

  data: () => ({
    loading: false,
    errorMessage: '',
    excludedFields: [
      'id',
      'createdAt',
      'updatedAt',
      'Items'
    ]
  }),

  methods: {
    closeEdit () {
      console.log('closeEdit triggered')
      this.$emit('closeEdit')
      this.$store.commit('setCustomers', [])
      this.errorMessage = ''
      this.loading = false
    },

    async saveChanges () {
      console.log('saveChanges triggered')

      this.loading = true

      try {
        await axios.patch(process.env.VUE_APP_API_URL + '/customer/' + this.propCustomer.id, this.propCustomer)
        this.closeEdit()
      } catch (err) {
        console.error('Error trying to saveChanges axios.patch()', err)
        this.errorMessage = err
        this.loading = false
      }
    },

    async deleteCustomer (confirmDelete) {
      console.log('deleteCustomer triggered')

      if (confirmDelete) {
        this.loading = true

        try {
          await axios.delete(process.env.VUE_APP_API_URL + '/customer/' + this.propCustomer.id)
          this.loading = false
          this.closeEdit()
          this.$router.push('/')
        } catch (err) {
          console.error('Error trying to deleteCustomer axios.del()', err)
          this.errorMessage = err
          this.loading = false
        }
      } else {
        console.log('User cancelled verification')
      }
    }
  },

  computed: {}
}
</script>
